import React from "react";
import { Dialog } from "primereact/dialog";
import PropTypes from "prop-types";
import CustomeButton from "../../../components/Button/index";

export default function DeleteModal({
  visible,
  isLoading,
  closeModal,
  deleteUserAccess,
  selectedEntity,
}) {
  return (
    <div className="modal-main-container card flex justify-content-center">
      <Dialog
        visible={visible}
        onHide={closeModal}
        className="user-delete-confirmation"
      >
        <p className="delete-dialog-heading mt-5">
          {`Are you sure you want to remove ${selectedEntity?.name} (${selectedEntity?.country})?`}
        </p>
        <p className="delete-dialog-desc">
          Deleting this entity will permanently remove access to records. Do you
          want to proceed?
        </p>
        <div className="flex justify-content-end mt-5">
          <CustomeButton
            label="Cancel"
            variant="outlined"
            className="mr-2"
            onClick={closeModal}
          />
          <CustomeButton
            label={!isLoading && "Yes, remove"}
            variant="remove"
            onClick={deleteUserAccess}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </Dialog>
    </div>
  );
}

DeleteModal.propTypes = {
  isLoading: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteUserAccess: PropTypes.func.isRequired,
  selectedEntity: PropTypes.shape({
    name: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
};
DeleteModal.defaultProps = {
  selectedEntity: {
    name: "Unknown Entity",
    country: "Unknown Country",
  },
};
